import { useLocation } from "react-router-dom";
import AdSlot from "@/components/AdSlot";
import { useAdSetting } from "@/lib/adSettings";

// Matches team/trainer/trainer-listing/event/player detail pages (single id segment,
// so /teams/:id/edit is excluded).
const DETAIL_RE = /^\/(teams|trainers|trainer-listings|events|players)\/[^/]+$/;

// A horizontal banner shown at the very bottom of a listing detail page, just above
// the global footer. Admin-toggleable ("detail_bottom") and hidden for Pro members.
export default function DetailBottomAd() {
    const { pathname } = useLocation();
    const on = useAdSetting("detail_bottom");
    if (!on || !DETAIL_RE.test(pathname)) return null;
    return (
        <div className="max-w-5xl mx-auto px-6 md:px-8 pb-8" data-testid="detail-bottom-ad">
            <AdSlot slot={process.env.REACT_APP_ADSENSE_DETAIL_SLOT} format="horizontal" minHeight={90} placement="detail_bottom" />
        </div>
    );
}
